import CallMergeIcon from '@mui/icons-material/CallMerge'
import QuarantineModal from '@/components/DataAdmin/QuarantineModal/QuarantineModal'
import { useUnmountingDelay } from '@/hooks/useUnmountingDelay'
import { StandarizedGolfPlayer } from '@/views/DataAdmin/types'

import { ActionMenuItem } from '../ActionMenuItem/ActionMenuItem'
import { useActionMenuContext } from '../context/ActionMenuContext'
import { MenuItemLike } from '../index.types'

type Props = MenuItemLike & {
  onSubmit?: () => void
}

export const ActionMergeQuarantineDialog = ({
  overrideText,
  displaySeparately,
  onSubmit
}: Props) => {
  const { row: quarantinePlayer } = useActionMenuContext<StandarizedGolfPlayer>()
  const { close, open, isMounted, isOpen } = useUnmountingDelay()

  return (
    <>
      <ActionMenuItem
        text={overrideText || 'Merge'}
        onClick={open}
        icon={<CallMergeIcon />}
        displaySeparately={displaySeparately}
      />

      {isMounted && (
        <QuarantineModal
          onSubmit={() => {
            onSubmit?.()
            close()
          }}
          quarantinePlayer={quarantinePlayer}
          open={isOpen}
          setModalOpen={(val) => val === false && close()}
        />
      )}
    </>
  )
}
